<template>
	<TopTab />
	<div class="artist-container">
		<img src="@/assets/imgs/bg1.png" alt="" class="bg">
		<div class="search">
			<van-search v-model="searchValue" placeholder="请输入艺术家姓名" />
		</div>
		<div class="tabbar">
			<span :class="{ active: currentTab == 1 }" @click="changeTab(1)">热门艺术家</span>
			<span :class="{ active: currentTab == 2 }" @click="changeTab(2)">推荐艺术家</span>
		</div>
		<div class="list">
			<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getArtistList">
				<ul>
					<li class="artist_item" v-for="item in artistList" :key="item.id" @click="router.push({ path: '/artist-detail', query: { id: item.id } })">
						<img :src="item.avatar" alt="">
						<h6>{{ item.artistName }}</h6>
						<p>{{ item.firstTitle }}</p>
					</li>
				</ul>
			</van-list>
		</div>
	</div>
	<FooterBar />
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, ref } from 'vue'
import { http } from '@/request/front'
import { useRouter } from 'vue-router'
import FooterBar from '@/views/front/components/FooterBar.vue'

const router = useRouter()
const artistList = ref([])
const loading = ref(false)
const searchValue = ref('')
const currentTab = ref(1)
const finished = ref(false)
const pageNum = ref(1)
const pageSize = ref(12)


onMounted(() => {
	getArtistList()
})

const getArtistList = async () => {
	loading.value = true
	http.get(`/pc/artist/home/list?page=${pageNum.value}&limit=${pageSize.value}&isRecommended=${currentTab.value == 2 ? 1 : ''}&isHot=${currentTab.value == 1 ? 1 : ''}`).then(res => {
		loading.value = false
		artistList.value.push(...res.data.rows)
		finished.value = artistList.value.length >= res.data.total
		pageNum.value++
	})
}

function changeTab(tab) {
	currentTab.value = tab
	pageNum.value = 1
	finished.value = false
	artistList.value = []
	getArtistList()
}
</script>

<style scoped lang="scss">
.artist-container {
	padding-bottom: 50px;

	.bg {
		width: 100%;
		height: 161rem;
	}

	.search {
		margin: 10rem;
	}
}

.van-cell {
	display: flex;
	align-items: center;
}

.tabbar {
	display: flex;
	border-bottom: 1px solid #F0F0F0;
	margin: 0 15rem;

	span {
		display: block;
		width: 50%;
		text-align: center;
		line-height: 40rem;
		height: 40rem;
		color: #9D9D9D;
	}

	.active {
		color: #000;
		border-bottom: 1px solid #000;
	}
}

.list {
	margin-top: 10rem; padding: 0 10rem;
	ul {
		display: flex;
		flex-wrap: wrap;
	}

	.artist_item {
		width: 124rem; margin: 6rem;
		img {
			width: 124rem;
			height: 124rem;
			object-fit: cover;
		}
		h6{
			height: 30rem; line-height: 30rem;
		}
		p{
			color: #999999; font-size: 12rem;
		}
	}
}
</style>
